import React from "react";
import FrontendLayout from "../FrontendLayout";
import { useCustomerContext } from "../../context/CustomerContext";
import Menu from "./Menu";

const Profile = () => {
  const { customerData } = useCustomerContext();
  const hasCustomerData = customerData && Object.keys(customerData).length > 0;
  const customerName = customerData?.name || "Nexways Customer";
  const customerInitials = customerName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("") || "NC";
  const profileItems = [
    { label: "Full Name", value: customerData?.name, icon: "fa-user" },
    { label: "Email Address", value: customerData?.email, icon: "fa-envelope" },
    { label: "Mobile Number", value: customerData?.mobile, icon: "fa-phone" },
  ];

  return (
    <FrontendLayout>
      <div className="account-page">
        <div className="container">
          <Menu
            title="My Profile"
            subtitle="Keep your account details up to date for smoother bookings."
          />
          <div className="account-panel">
            <div className="account-panel-header">
              <div>
                <span className="account-section-label">Profile Details</span>
                <h2>Personal Information</h2>
              </div>
            </div>
            <div className="account-panel-body">
              {hasCustomerData ? (
                <>
                  <div className="profile-overview">
                    <div className="profile-overview-identity">
                      <span className="profile-overview-avatar">{customerInitials}</span>
                      <div>
                        <span className="profile-overview-label">Customer account</span>
                        <h3>{customerName}</h3>
                        <p>{customerData?.email || "Your verified Nexways profile"}</p>
                      </div>
                    </div>
                    <span className="profile-active-badge">
                      <i className="fa fa-check-circle"></i> Active account
                    </span>
                  </div>

                  <div className="row g-3 profile-details-grid">
                    {profileItems.map((item) => (
                      <div className="col-md-4" key={item.label}>
                        <div className="profile-info-box">
                          <div className="profile-info-icon">
                            <i className={`fa ${item.icon}`}></i>
                          </div>
                          <div>
                            <span>{item.label}</span>
                            <strong>{item.value || "-"}</strong>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="profile-security-note">
                    <span><i className="fa fa-shield-alt"></i></span>
                    <div>
                      <strong>Your account information is protected</strong>
                      <p>These details are used to keep bookings accurate and communication seamless.</p>
                    </div>
                  </div>
                </>
              ) : (
                <div className="account-empty-state">
                  <i className="fa fa-user-circle"></i>
                  <h5>Profile details not available</h5>
                  <p>Please login again to view your account information.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </FrontendLayout>
  );
};

export default Profile;
